var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAnger(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: "100px",
    width: "100px",
    fill: "#ec7b47",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "-255 347 100 100",
    enableBackground: "new -255 347 100 100",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M-205,367c16.569,0,30,13.431,30,30s-13.431,30-30,30s-30-13.431-30-30S-221.569,367-205,367 M-205,362   c-19.299,0-35,15.701-35,35s15.701,35,35,35s35-15.701,35-35S-185.701,362-205,362L-205,362z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M-211.857,393.68c-0.214,0-0.432-0.027-0.648-0.085l-11.167-2.992c-1.333-0.357-2.125-1.729-1.768-3.062    c0.357-1.334,1.728-2.127,3.062-1.768l11.167,2.992c1.333,0.357,2.125,1.729,1.768,3.062    C-209.743,392.943-210.753,393.68-211.857,393.68z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-198.143,393.68c-1.104,0-2.114-0.736-2.414-1.854c-0.357-1.333,0.435-2.705,1.768-3.062l11.168-2.992    c1.333-0.353,2.705,0.434,3.062,1.768c0.357,1.333-0.435,2.705-1.768,3.062l-11.168,2.992    C-197.711,393.652-197.929,393.68-198.143,393.68z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M-189.585,413.827c-0.588,0-1.178-0.206-1.653-0.626c-3.802-3.355-8.689-5.203-13.761-5.203s-9.959,1.848-13.761,5.203    c-1.036,0.914-2.615,0.814-3.528-0.22c-0.914-1.035-0.815-2.614,0.22-3.528c4.715-4.163,10.777-6.456,17.069-6.456    s12.354,2.292,17.07,6.456c1.036,0.913,1.133,2.493,0.22,3.528C-188.204,413.541-188.893,413.827-189.585,413.827z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAnger);
export default __webpack_public_path__ + "static/media/anger.399e54530f89f29850844349b36af392.svg";
export { ForwardRef as ReactComponent };